/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e40f75db67404865d5afcaaedf20c1604de27482";
